import { getCorrelationId } from '../logging';

export const getUserInfoForAnalytics = async ({
    userInfoForAnalytics,
    token,
}: {
    userInfoForAnalytics: string;
    token: string;
}): Promise<Response> => {
    const correlationId = getCorrelationId();

    // add event tracking
    const resp = await fetch(userInfoForAnalytics, {
        method: 'GET',
        headers: {
            Authorization: token || '',
            'Content-Type': 'application/json',
            'X-Request-Id': correlationId,
        },
    });
    return resp;
};
